import { Box, Grid } from "@mui/material";
import { Container } from "@mui/system";
import imgAnniversaire from "../../assets/images/VitalEau-Anniversaire-Piscine-1552.jpg";
import { Button } from "../../stories/atoms/Button";

export const BirthdayHighlight = () => {
    return (
        <section className="section-birthday-home">
            <Container maxWidth="xl">
                <Grid container spacing={4} alignItems="center">
                    {/* Texte */}
                    <Grid item xs={12} md={6}>
                        <p className="badge">Moments uniques</p>

                        <h2>Fêtez votre anniversaire à la piscine !</h2>

                        <p>
                            Offrez à vos enfants une expérience inoubliable dans un cadre sécurisé et festif. Bassin privatisé, jeux aquatiques et
                            ambiance sur-mesure.
                        </p>

                        <Box display="flex" gap={2} flexWrap="wrap" mb={3}>
                            <Box className="feature">🏊 Privatisation exclusive</Box>
                            <Box className="feature">🎵 Jeux & musique</Box>
                        </Box>

                        <Button label="En savoir plus" style={{ width: "fit-content" }} primary href="/anniversaire" />
                    </Grid>

                    {/* Image */}
                    <Grid item xs={12} md={6}>
                        <Box
                            component="img"
                            src={imgAnniversaire}
                            alt="Anniversaire piscine enfants"
                            sx={{
                                width: "100%",
                                borderRadius: "20px",
                                // boxShadow: 3,
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};
